<template>
  <dara-item-table-layout>
    <template #name>
      <div class="cursor--pointer title" @click="goToItem">
        {{ data[keys[1]] }}
      </div>
    </template>
    <template #firstColumn>
      {{ data[keys[2]] }}
    </template>
    <template #secondColumn>
      {{ data[keys[3]] }}
    </template>
    <template #thirdColumn>
      {{ data[keys[4]] }}
    </template>
    <template #fourthColumn>
      {{ data[keys[5]] }}
    </template>
  </dara-item-table-layout>
</template>

<script>
import DaraItemTableLayout from '@/layouts/ItemTableLayout.vue';
import { goToOpenArticle } from '@/modules/article/article.routes';
import { goToOpenTrack } from '@/modules/track/track.routes';
import { goToOpenQuestion } from '@/modules/question/question.routes';

export default {
  name: 'DaraTableItem',
  components: {
    DaraItemTableLayout,
  },
  props: {
    data: Object,
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      keys: Object.keys(this.data),
    };
  },
  methods: {
    goToItem() {
      if (this.type === 'article') goToOpenArticle(this.$router, this.data);
      if (this.type === 'question') goToOpenQuestion(this.$router, this.data);
      if (this.type === 'track') goToOpenTrack(this.$router, this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/scss/variables/colors';

  .title {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .title:hover {
    color: $primary;
  }
</style>
